interface AuthenticationErrorInput {
  code: string;
  details?: unknown;
}

const errorsMapper: Record<string, string> = {
  'auth/user-not-found': 'Usuário não encontrado.',
  'auth/wrong-password': 'A senha está incorreta ou este usuário não possui uma senha.',
  'auth/too-many-requests': 'O acesso a esta conta foi desabilitado temporariamente por inúmeras tentativas recentes. Resete sua senha ou aguarde.',
};

function encondeMessage(code: string) {
  return errorsMapper[code];
}

export default class AuthenticationError extends Error {
  constructor(err: unknown);

  constructor(err: AuthenticationErrorInput);

  constructor(err: string);

  constructor(err?: AuthenticationErrorInput | string) {
    super(typeof err === 'string' ? err : encondeMessage(err?.code!));
  }
}
